/**
 * Demo data for HR page when API is unavailable (e.g. production without backend).
 * Matches backend API response shapes so the UI works without changes.
 */

const DEMO_DEPARTMENT_IDS = {
  ENG: 'a1000000-0000-4000-8000-000000000001',
  PROD: 'a1000000-0000-4000-8000-000000000002',
  MKT: 'a1000000-0000-4000-8000-000000000003',
  OPS: 'a1000000-0000-4000-8000-000000000004',
  COMM: 'a1000000-0000-4000-8000-000000000005',
};

const DEMO_POSITION_IDS = {
  'ENG-FSE': 'b2000000-0000-4000-8000-000000000001',
  'ENG-FE': 'b2000000-0000-4000-8000-000000000002',
  'ENG-BE': 'b2000000-0000-4000-8000-000000000003',
  'ENG-INT': 'b2000000-0000-4000-8000-000000000004',
  'PROD-PM': 'b2000000-0000-4000-8000-000000000005',
  'PROD-UX': 'b2000000-0000-4000-8000-000000000006',
  'MKT-LEAD': 'b2000000-0000-4000-8000-000000000007',
  'MKT-CA': 'b2000000-0000-4000-8000-000000000008',
  'OPS-COORD': 'b2000000-0000-4000-8000-000000000009',
  'COMM-ACL': 'b2000000-0000-4000-8000-00000000000a',
  'ENG-SEC': 'b2000000-0000-4000-8000-00000000000b',
};

export const DEMO_DEPARTMENTS = [
  { id: DEMO_DEPARTMENT_IDS.ENG, name: 'Engineering', code: 'ENG', description: 'Product & platform engineering', display_order: 0, is_active: true, people_count: 6 },
  { id: DEMO_DEPARTMENT_IDS.PROD, name: 'Product', code: 'PROD', description: 'Product management & design', display_order: 1, is_active: true, people_count: 3 },
  { id: DEMO_DEPARTMENT_IDS.MKT, name: 'Marketing', code: 'MKT', description: 'Marketing & campus ambassadors', display_order: 2, is_active: true, people_count: 4 },
  { id: DEMO_DEPARTMENT_IDS.OPS, name: 'Operations', code: 'OPS', description: 'Operations & coordination', display_order: 3, is_active: true, people_count: 2 },
  { id: DEMO_DEPARTMENT_IDS.COMM, name: 'Community', code: 'COMM', description: 'Community & area leads', display_order: 4, is_active: true, people_count: 3 },
];

export const DEMO_POSITIONS = [
  { id: DEMO_POSITION_IDS['ENG-FSE'], title: 'AI/Full Stack Engineer', code: 'ENG-FSE', employment_type: 'full_time', department_id: DEMO_DEPARTMENT_IDS.ENG, is_active: true },
  { id: DEMO_POSITION_IDS['ENG-FE'], title: 'Frontend Engineer', code: 'ENG-FE', employment_type: 'full_time', department_id: DEMO_DEPARTMENT_IDS.ENG, is_active: true },
  { id: DEMO_POSITION_IDS['ENG-BE'], title: 'Backend Engineer', code: 'ENG-BE', employment_type: 'full_time', department_id: DEMO_DEPARTMENT_IDS.ENG, is_active: true },
  { id: DEMO_POSITION_IDS['ENG-INT'], title: 'Engineering Intern', code: 'ENG-INT', employment_type: 'intern', department_id: DEMO_DEPARTMENT_IDS.ENG, is_active: true },
  { id: DEMO_POSITION_IDS['PROD-PM'], title: 'Product Manager', code: 'PROD-PM', employment_type: 'full_time', department_id: DEMO_DEPARTMENT_IDS.PROD, is_active: true },
  { id: DEMO_POSITION_IDS['PROD-UX'], title: 'UI/UX Designer', code: 'PROD-UX', employment_type: 'full_time', department_id: DEMO_DEPARTMENT_IDS.PROD, is_active: true },
  { id: DEMO_POSITION_IDS['MKT-LEAD'], title: 'Marketing Lead', code: 'MKT-LEAD', employment_type: 'full_time', department_id: DEMO_DEPARTMENT_IDS.MKT, is_active: true },
  { id: DEMO_POSITION_IDS['MKT-CA'], title: 'Campus Ambassador', code: 'MKT-CA', employment_type: 'intern', department_id: DEMO_DEPARTMENT_IDS.MKT, is_active: true },
  { id: DEMO_POSITION_IDS['OPS-COORD'], title: 'Operations Coordinator', code: 'OPS-COORD', employment_type: 'full_time', department_id: DEMO_DEPARTMENT_IDS.OPS, is_active: true },
  { id: DEMO_POSITION_IDS['COMM-ACL'], title: 'Area/City Lead', code: 'COMM-ACL', employment_type: 'part_time', department_id: DEMO_DEPARTMENT_IDS.COMM, is_active: true },
  { id: DEMO_POSITION_IDS['ENG-SEC'], title: 'Security Engineer', code: 'ENG-SEC', employment_type: 'full_time', department_id: DEMO_DEPARTMENT_IDS.ENG, is_active: true },
];

const person = (id, display_name, email, first_name, last_name, deptId, deptName, posId, posTitle, employment_type, status, start_date, phone, manager_name = null, today_attendance_status = null) => ({
  id,
  display_name,
  email,
  first_name,
  last_name,
  department_id: deptId,
  department_name: deptName,
  position_id: posId,
  position_title: posTitle,
  employment_type,
  status,
  start_date,
  end_date: null,
  phone,
  manager_name,
  notes: null,
  today_attendance_status,
});

export const DEMO_PEOPLE = [
  person('c3000000-0000-4000-8000-000000000001', 'Admin User', 'admin@chinesecommunity.ai', 'Admin', 'User', DEMO_DEPARTMENT_IDS.ENG, 'Engineering', DEMO_POSITION_IDS['ENG-FSE'], 'AI/Full Stack Engineer', 'full_time', 'active', '2024-01-15', null, null),
  person('c3000000-0000-4000-8000-000000000002', '张伟', 'wei.zhang@ccai.dev', '伟', '张', DEMO_DEPARTMENT_IDS.ENG, 'Engineering', DEMO_POSITION_IDS['ENG-FSE'], 'AI/Full Stack Engineer', 'full_time', 'active', '2024-06-01', '(415) 555-0101', null),
  person('c3000000-0000-4000-8000-000000000003', '陈明玉', 'emily.chen@ccai.dev', '明玉', '陈', DEMO_DEPARTMENT_IDS.ENG, 'Engineering', DEMO_POSITION_IDS['ENG-FE'], 'Frontend Engineer', 'full_time', 'active', '2024-08-01', '(415) 555-0102', '张伟'),
  person('c3000000-0000-4000-8000-000000000004', '刘凯文', 'kevin.liu@ccai.dev', '凯文', '刘', DEMO_DEPARTMENT_IDS.ENG, 'Engineering', DEMO_POSITION_IDS['ENG-BE'], 'Backend Engineer', 'full_time', 'active', '2024-09-15', '(415) 555-0103', '张伟'),
  person('c3000000-0000-4000-8000-000000000005', '王思涵', 'sophia.wang@ccai.dev', '思涵', '王', DEMO_DEPARTMENT_IDS.ENG, 'Engineering', DEMO_POSITION_IDS['ENG-INT'], 'Engineering Intern', 'intern', 'active', '2025-01-06', '(415) 555-0104', '张伟'),
  person('c3000000-0000-4000-8000-000000000006', '李杰森', 'jason.li@ccai.dev', '杰森', '李', DEMO_DEPARTMENT_IDS.ENG, 'Engineering', DEMO_POSITION_IDS['ENG-FSE'], 'AI/Full Stack Engineer', 'full_time', 'active', '2024-05-01', '(415) 555-0105', '张伟', 'leave'),
  person('c3000000-0000-4000-8000-000000000007', '吴美琳', 'michelle.wu@ccai.dev', '美琳', '吴', DEMO_DEPARTMENT_IDS.PROD, 'Product', DEMO_POSITION_IDS['PROD-PM'], 'Product Manager', 'full_time', 'active', '2024-07-01', '(415) 555-0201', null),
  person('c3000000-0000-4000-8000-000000000008', '黄睿安', 'ryan.huang@ccai.dev', '睿安', '黄', DEMO_DEPARTMENT_IDS.PROD, 'Product', DEMO_POSITION_IDS['PROD-UX'], 'UI/UX Designer', 'full_time', 'active', '2024-10-01', '(415) 555-0202', '吴美琳'),
  person('c3000000-0000-4000-8000-000000000009', '林涵', 'hannah.lin@ccai.dev', '涵', '林', DEMO_DEPARTMENT_IDS.PROD, 'Product', DEMO_POSITION_IDS['PROD-UX'], 'UI/UX Designer', 'part_time', 'active', '2024-11-15', '(415) 555-0203', '吴美琳'),
  person('c3000000-0000-4000-8000-00000000000a', '赵大卫', 'david.zhao@ccai.dev', '大卫', '赵', DEMO_DEPARTMENT_IDS.MKT, 'Marketing', DEMO_POSITION_IDS['MKT-LEAD'], 'Marketing Lead', 'full_time', 'active', '2024-06-15', '(415) 555-0301', null),
  person('c3000000-0000-4000-8000-00000000000b', '孙洁西', 'jessica.sun@ccai.dev', '洁西', '孙', DEMO_DEPARTMENT_IDS.MKT, 'Marketing', DEMO_POSITION_IDS['MKT-CA'], 'Campus Ambassador', 'intern', 'active', '2025-01-15', '(415) 555-0302', '赵大卫'),
  person('c3000000-0000-4000-8000-00000000000c', '杨克里斯', 'chris.yang@ccai.dev', '克里斯', '杨', DEMO_DEPARTMENT_IDS.MKT, 'Marketing', DEMO_POSITION_IDS['MKT-CA'], 'Campus Ambassador', 'intern', 'active', '2025-01-20', '(415) 555-0303', '赵大卫'),
  person('c3000000-0000-4000-8000-00000000000d', '徐艾米', 'amy.xu@ccai.dev', '艾米', '徐', DEMO_DEPARTMENT_IDS.MKT, 'Marketing', DEMO_POSITION_IDS['MKT-CA'], 'Campus Ambassador', 'intern', 'offboarded', '2024-09-01', '(415) 555-0304', '赵大卫'),
  person('c3000000-0000-4000-8000-00000000000e', '马托尼', 'tony.ma@ccai.dev', '托尼', '马', DEMO_DEPARTMENT_IDS.OPS, 'Operations', DEMO_POSITION_IDS['OPS-COORD'], 'Operations Coordinator', 'full_time', 'active', '2024-06-01', '(415) 555-0401', null),
  person('c3000000-0000-4000-8000-00000000000f', '周丽莎', 'lisa.zhou@ccai.dev', '丽莎', '周', DEMO_DEPARTMENT_IDS.OPS, 'Operations', DEMO_POSITION_IDS['OPS-COORD'], 'Operations Coordinator', 'part_time', 'active', '2024-11-01', '(415) 555-0402', '马托尼'),
  person('c3000000-0000-4000-8000-000000000010', '郭彼得', 'peter.guo@ccai.dev', '彼得', '郭', DEMO_DEPARTMENT_IDS.COMM, 'Community', DEMO_POSITION_IDS['COMM-ACL'], 'Area/City Lead', 'part_time', 'active', '2024-08-01', '(415) 555-0501', null),
  person('c3000000-0000-4000-8000-000000000011', '江南希', 'nancy.jiang@ccai.dev', '南希', '江', DEMO_DEPARTMENT_IDS.COMM, 'Community', DEMO_POSITION_IDS['COMM-ACL'], 'Area/City Lead', 'volunteer', 'active', '2024-10-01', '(415) 555-0502', '郭彼得'),
  person('c3000000-0000-4000-8000-000000000012', '谭亚历', 'alex.tan@ccai.dev', '亚历', '谭', DEMO_DEPARTMENT_IDS.COMM, 'Community', DEMO_POSITION_IDS['COMM-ACL'], 'Area/City Lead', 'volunteer', 'active', '2025-01-10', '(415) 555-0503', '郭彼得'),
];

/** Paginate and filter demo people (mirrors backend list_people behavior for directory view). */
export function getDemoPeopleList(params = {}) {
  let list = [...DEMO_PEOPLE];
  const { search, department_id, status, employment_type, sort, page = 1, limit = 20 } = params;

  if (search && search.trim()) {
    const q = search.trim().toLowerCase();
    list = list.filter(
      (p) =>
        (p.display_name && p.display_name.toLowerCase().includes(q)) ||
        (p.email && p.email.toLowerCase().includes(q)) ||
        (p.first_name && p.first_name.toLowerCase().includes(q)) ||
        (p.last_name && p.last_name.toLowerCase().includes(q))
    );
  }
  if (department_id) list = list.filter((p) => p.department_id === department_id);
  if (status) list = list.filter((p) => (status === 'on_leave' ? (p.today_attendance_status === 'leave') : (p.status === status)));
  if (employment_type) list = list.filter((p) => p.employment_type === employment_type);

  if (sort === 'name_desc') list.sort((a, b) => (b.display_name || '').localeCompare(a.display_name || ''));
  else list.sort((a, b) => (a.display_name || '').localeCompare(b.display_name || ''));

  const total = list.length;
  const pages = Math.max(1, Math.ceil(total / limit));
  const start = (page - 1) * limit;
  const items = list.slice(start, start + limit);

  return { items, total, page, limit, pages };
}

// ── Attendance seed (for Attendance tab demo) ───────────
const DEMO_ATTENDANCE_BY_PERSON = [
  { id: 'c3000000-0000-4000-8000-000000000001', name: 'Admin User', status: 'present', inHour: 8, inMin: 30, outHour: 18, outMin: 0 },
  { id: 'c3000000-0000-4000-8000-000000000002', name: '张伟', status: 'present', inHour: 9, inMin: 0, outHour: 17, outMin: 30 },
  { id: 'c3000000-0000-4000-8000-000000000003', name: '陈明玉', status: 'present', inHour: 8, inMin: 45, outHour: 17, outMin: 45 },
  { id: 'c3000000-0000-4000-8000-000000000004', name: '刘凯文', status: 'late', inHour: 10, inMin: 15, outHour: 18, outMin: 30 },
  { id: 'c3000000-0000-4000-8000-000000000005', name: '王思涵', status: 'present', inHour: 9, inMin: 15, outHour: 17, outMin: 0 },
  { id: 'c3000000-0000-4000-8000-000000000006', name: '李杰森', status: 'leave', inHour: null, inMin: null, outHour: null, outMin: null },
  { id: 'c3000000-0000-4000-8000-000000000007', name: '吴美琳', status: 'wfh', inHour: 9, inMin: 0, outHour: 17, outMin: 30 },
  { id: 'c3000000-0000-4000-8000-000000000008', name: '黄睿安', status: 'present', inHour: 8, inMin: 55, outHour: 18, outMin: 0 },
  { id: 'c3000000-0000-4000-000000000009', name: '林涵', status: 'present', inHour: 10, inMin: 0, outHour: 16, outMin: 0 },
  { id: 'c3000000-0000-4000-8000-00000000000a', name: '赵大卫', status: 'present', inHour: 9, inMin: 0, outHour: 17, outMin: 45 },
  { id: 'c3000000-0000-4000-8000-00000000000b', name: '孙洁西', status: 'present', inHour: 9, inMin: 30, outHour: 17, outMin: 0 },
  { id: 'c3000000-0000-4000-8000-00000000000c', name: '杨克里斯', status: 'absent', inHour: null, inMin: null, outHour: null, outMin: null },
  { id: 'c3000000-0000-4000-8000-00000000000e', name: '马托尼', status: 'present', inHour: 8, inMin: 0, outHour: 17, outMin: 30 },
  { id: 'c3000000-0000-4000-8000-00000000000f', name: '周丽莎', status: 'present', inHour: 9, inMin: 0, outHour: 17, outMin: 0 },
  { id: 'c3000000-0000-4000-8000-000000000010', name: '郭彼得', status: 'present', inHour: 8, inMin: 30, outHour: 17, outMin: 0 },
  { id: 'c3000000-0000-4000-8000-000000000011', name: '江南希', status: 'present', inHour: 9, inMin: 15, outHour: 17, outMin: 15 },
  { id: 'c3000000-0000-4000-8000-000000000012', name: '谭亚历', status: 'present', inHour: 9, inMin: 0, outHour: 17, outMin: 30 },
];

/** Returns demo attendance rows for a given date (YYYY-MM-DD). Clock in/out are set from the date + fixed times. */
export function getDemoAttendance(dateStr) {
  const d = dateStr ? new Date(dateStr + 'T12:00:00Z') : new Date();
  const y = d.getUTCFullYear();
  const m = d.getUTCMonth();
  const day = d.getUTCDate();
  return DEMO_ATTENDANCE_BY_PERSON.map((p) => {
    const clock_in_at =
      p.inHour != null && p.inMin != null
        ? new Date(Date.UTC(y, m, day, p.inHour, p.inMin, 0)).toISOString()
        : null;
    const clock_out_at =
      p.outHour != null && p.outMin != null
        ? new Date(Date.UTC(y, m, day, p.outHour, p.outMin, 0)).toISOString()
        : null;
    return {
      id: p.id,
      employee_id: p.id,
      employee_name: p.name,
      date: dateStr || d.toISOString().slice(0, 10),
      clock_in_at,
      clock_out_at,
      status: p.status,
    };
  });
}

// ── Analytics ─────────────────────────────────────────
export const DEMO_ANALYTICS = {
  total_active: 17,
  avg_tenure_months: 7.2,
  attrition_count: 1,
  headcount_by_department: [
    { name: 'Engineering', count: 6 },
    { name: 'Product', count: 3 },
    { name: 'Marketing', count: 4 },
    { name: 'Operations', count: 2 },
    { name: 'Community', count: 3 },
  ],
  tenure_buckets: [
    { bucket: '0–3 mo', count: 4 },
    { bucket: '3–6 mo', count: 3 },
    { bucket: '6–12 mo', count: 6 },
    { bucket: '12+ mo', count: 4 },
  ],
};

// ── Review cycles & performance reviews ─────────────────
const DEMO_CYCLE_IDS = {
  Q4_2025: 'd4000000-0000-4000-8000-000000000001',
  Q1_2026: 'd4000000-0000-4000-8000-000000000002',
  ANNUAL: 'd4000000-0000-4000-8000-000000000003',
};

export const DEMO_REVIEW_CYCLES = [
  { id: DEMO_CYCLE_IDS.Q4_2025, name: 'Q4 2025', start_date: '2025-10-01', end_date: '2025-12-15', status: 'completed', review_count: 12 },
  { id: DEMO_CYCLE_IDS.Q1_2026, name: 'Q1 2026', start_date: '2026-01-06', end_date: '2026-03-31', status: 'in_progress', review_count: 5 },
  { id: DEMO_CYCLE_IDS.ANNUAL, name: 'Annual 2026', start_date: '2026-01-01', end_date: '2026-12-31', status: 'draft', review_count: 0 },
];

export const DEMO_REVIEWS = [
  { id: 'e5000000-0000-4000-8000-000000000001', employee_id: 'c3000000-0000-4000-8000-000000000002', cycle_id: DEMO_CYCLE_IDS.Q4_2025, employee_name: '张伟', cycle_name: 'Q4 2025', manager_name: 'Admin User', status: 'completed', rating: 'exceeds' },
  { id: 'e5000000-0000-4000-8000-000000000002', employee_id: 'c3000000-0000-4000-8000-000000000003', cycle_id: DEMO_CYCLE_IDS.Q4_2025, employee_name: '陈明玉', cycle_name: 'Q4 2025', manager_name: '张伟', status: 'completed', rating: 'meets_expectations' },
  { id: 'e5000000-0000-4000-8000-000000000003', employee_id: 'c3000000-0000-4000-8000-000000000007', cycle_id: DEMO_CYCLE_IDS.Q4_2025, employee_name: '吴美琳', cycle_name: 'Q4 2025', manager_name: null, status: 'completed', rating: 'exceeds' },
  { id: 'e5000000-0000-4000-8000-000000000004', employee_id: 'c3000000-0000-4000-8000-000000000002', cycle_id: DEMO_CYCLE_IDS.Q1_2026, employee_name: '张伟', cycle_name: 'Q1 2026', manager_name: 'Admin User', status: 'manager_submitted', rating: 'exceeds' },
  { id: 'e5000000-0000-4000-8000-000000000005', employee_id: 'c3000000-0000-4000-8000-00000000000a', cycle_id: DEMO_CYCLE_IDS.Q1_2026, employee_name: '赵大卫', cycle_name: 'Q1 2026', manager_name: null, status: 'self_submitted', rating: null },
];

export function getDemoReviewsForCycle(cycleId) {
  return DEMO_REVIEWS.filter((r) => r.cycle_id === cycleId);
}

// ── Upcoming leave (approved, overlapping next 14 days) ──
const inDays = (d) => {
  const dt = new Date();
  dt.setDate(dt.getDate() + d);
  return dt.toISOString().slice(0, 10);
};

export const DEMO_UPCOMING_LEAVE = [
  { id: 'f6000000-0000-4000-8000-000000000001', employee_name: '李杰森', leave_type: 'vacation', start_date: inDays(3), end_date: inDays(10) },
  { id: 'f6000000-0000-4000-8000-000000000002', employee_name: '林涵', leave_type: 'personal', start_date: inDays(7), end_date: inDays(8) },
];

// ── Announcements ───────────────────────────────────────
export const DEMO_ANNOUNCEMENTS = [
  { id: 'g7000000-0000-4000-8000-000000000001', title: 'Welcome to Q1 2026', content: 'Review cycles are open. Please complete self-assessments by end of month.', author_name: 'Admin User', created_at: new Date().toISOString() },
  { id: 'g7000000-0000-4000-8000-000000000002', title: 'Office closure – Chinese New Year', content: 'HQ will be closed Feb 10–12. Remote work as usual for other days.', author_name: 'Admin User', created_at: new Date(Date.now() - 86400000 * 5).toISOString() },
  { id: 'g7000000-0000-4000-8000-000000000003', title: 'New benefits open enrollment', content: 'Open enrollment for health and dental runs through Feb 28.', author_name: 'Admin User', created_at: new Date(Date.now() - 86400000 * 12).toISOString() },
];

// ── Company holidays (next 3 months) ─────────────────────
export const DEMO_HOLIDAYS = [
  { id: 'h8000000-0000-4000-8000-000000000001', date: '2026-02-10', name: 'Chinese New Year', location: 'All' },
  { id: 'h8000000-0000-4000-8000-000000000002', date: '2026-02-11', name: 'Chinese New Year', location: 'All' },
  { id: 'h8000000-0000-4000-8000-000000000003', date: '2026-05-25', name: 'Memorial Day', location: 'US' },
  { id: 'h8000000-0000-4000-8000-000000000004', date: '2026-07-04', name: 'Independence Day', location: 'US' },
];

// ── Benefit plans ───────────────────────────────────────
export const DEMO_BENEFIT_PLANS = [
  { id: 'i9000000-0000-4000-8000-000000000001', name: 'Health – Base', description: 'Medical base plan', plan_type: 'health', is_active: true },
  { id: 'i9000000-0000-4000-8000-000000000002', name: 'Health – Plus', description: 'Medical plus with dependents', plan_type: 'health', is_active: true },
  { id: 'i9000000-0000-4000-8000-000000000003', name: 'Dental', description: 'Dental PPO', plan_type: 'dental', is_active: true },
];

// ── PTO accrual policies ───────────────────────────────
export const DEMO_PTO_POLICIES = [
  { id: 'jA000000-0000-4000-8000-000000000001', name: 'Full-time', hours_per_month: 10, annual_cap_hours: 120, employment_type: 'full_time', is_active: true },
  { id: 'jA000000-0000-4000-8000-000000000002', name: 'Part-time', hours_per_month: 5, annual_cap_hours: 60, employment_type: 'part_time', is_active: true },
  { id: 'jA000000-0000-4000-8000-000000000003', name: 'Intern / Volunteer', hours_per_month: 4, annual_cap_hours: 48, employment_type: null, is_active: true },
];

// ── Audit log ──────────────────────────────────────────
export const DEMO_AUDIT_ITEMS = [
  { id: 'kB000000-0000-4000-8000-000000000001', employee_name: '谭亚历', action: 'create', actor_name: 'Admin User', created_at: new Date(Date.now() - 86400000 * 20).toISOString(), changes: { fields: ['display_name', 'email', 'department_id'] } },
  { id: 'kB000000-0000-4000-8000-000000000002', employee_name: '王思涵', action: 'update', actor_name: '张伟', created_at: new Date(Date.now() - 86400000 * 18).toISOString(), changes: { fields: ['position_id'] } },
  { id: 'kB000000-0000-4000-8000-000000000003', employee_name: '徐艾米', action: 'delete', actor_name: 'Admin User', created_at: new Date(Date.now() - 86400000 * 45).toISOString(), changes: { fields: ['status'] } },
  { id: 'kB000000-0000-4000-8000-000000000004', employee_name: '江南希', action: 'update', actor_name: '郭彼得', created_at: new Date(Date.now() - 86400000 * 30).toISOString(), changes: { fields: ['phone', 'emergency_contact'] } },
  { id: 'kB000000-0000-4000-8000-000000000005', employee_name: '周丽莎', action: 'create', actor_name: 'Admin User', created_at: new Date(Date.now() - 86400000 * 90).toISOString(), changes: { fields: ['display_name', 'email', 'department_id', 'position_id'] } },
];
